import React from "react";
import "../css/Navbar.css";
import { handleDownload } from './DownloadUtils';

const sections = [
  { id: "about", label: "About me", icon: "fa-solid fa-user" },
  { id: "experience", label: "Experience", icon: "fa-solid fa-contact-card" },
  { id: "portfolio", label: "Portfolio", icon: "fa-solid fa-briefcase" },
  { id: "techstack", label: "Tech stack", icon: "fa-solid fa-code" },
  { id: "contact", label: "Contact", icon: "fa-solid fa-envelope" },
  { id: "sociallinks", label: "Socials", icon: "fa-solid fa-people-group" },
];

const Navbar = ({ activeSection, setActiveSection }) => {
  return (
    <nav className="rail" aria-label="Sections">
      <ul className="rail-list">
        {sections.map(({ id, label, icon }) => (
          <li key={id}>
            <button
              type="button"
              className={`rail-item ${activeSection === id ? "is-active" : ""}`}
              aria-current={activeSection === id ? "page" : undefined}
              title={label}
              onClick={() => setActiveSection(id)}
            >
              <i className={icon} aria-hidden="true"></i>
              <span className="rail-label">{label}</span>
            </button>
          </li>
        ))}
        <li className="rail-divider" aria-hidden="true"></li>
        <li>
          <button
            type="button"
            className="rail-item"
            title="Download CV"
            onClick={() => handleDownload()}
          >
            <i className="fa-solid fa-cloud-arrow-down" aria-hidden="true"></i>
            <span className="rail-label">Download CV</span>
          </button>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
